import React from "react";
import Home from "./Home";
import DraggableHome from "./DraggableHome";

function Homes() {
  return <DraggableHome />;
}

export default Homes;
